import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getToday} from "../../store/reducers/InfoSlice";

interface HeaderProps {
}

interface MenuItem {
    link: string;
    text: string;
    submenu?: MenuItem[];
}

export const Header: React.FC<HeaderProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {

        dispatch(getToday());

        const intervalId = setInterval(() => {
            dispatch(getToday());
        }, 30000);

        return () => clearInterval(intervalId); // Clean up the interval on unmount
    }, [dispatch]);

    const menu: MenuItem[] = [
        {link: 'orders', text: 'Veod'},
        {link: 'inquiries', text: 'Päringud'},
        {
            link: 'partneridJaGrupid',
            text: 'Partnerid ja grupid',
            submenu: [
                {link: 'categories', text: 'Grupid'},
                {link: 'category-types', text: 'Grupi tüübid'},
                {link: 'services', text: 'Teenuse tüübid'},
                {link: 'vendors', text: 'Hankijad'},
                {link: 'clients', text: 'Kliendid'},
            ],
        },
        {link: 'send-email', text: 'Saada e-mail'},
        {link: 'send-sms', text: 'Saada SMS'},
        {link: 'emails', text: 'Mailid'},
        {
            link: 'myResults',
            text: 'Tulemused',
            submenu: [
                {link: 'results/me', text: 'Minu tulemused'},
                //{link: 'results/performance', text: 'Tulemusnäitajad'},
            ],
        },
        {
            link: 'checker',
            text: 'Checker',
            submenu: [
                {link: 'checker/loadings', text: 'Pealelaadimised'},
                {link: 'checker/unloadings', text: 'Mahalaadimised'}
            ],
        },
        {
            link: 'admin',
            text: 'Admin',
            submenu: [
                {link: 'users', text: 'Kasutajad'},
                {link: 'top-clients', text: 'Top kliendid'},
                {link: 'extensions', text: 'Pikendused'},
                {link: 'offline-reasons', text: 'Miks väljas'},
                {link: 'settings', text: 'Seaded'},
                {link: 'insurance', text: 'Kindlustuse hinnad'},
                {link: 'sms-senders', text: 'SMS saatjad'},
                {link: 'logs/d', text: 'D logi'},
                {link: 'advertising', text: 'Reklaam'},
            ],
        },
    ];

    return (
        <div id="header" className="clear">
            <ul id="nav">
                {menu.map((item, index) => (
                    <li key={index}>
                        <Link to={`/${item.link}`}>{item.text}</Link>
                        {item?.submenu && item?.submenu.length > 0 && (
                            <ul className="sub-menu">
                                {item.submenu?.map((subitem, subindex) => (
                                    <li key={subindex}>
                                        <Link to={`/${subitem.link}`}>{subitem.text}</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
                <li style={{paddingTop: '7px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px'}}>
                    <Link to="/inquiries/new" target="_blank" style={{padding: 0}}>
                        <img src={process.env.PUBLIC_URL + '/gfx/addwhite.png'}
                             style={{width: '20px', height: '20px'}}/>
                    </Link>
                </li>
                <li style={{paddingTop: '7px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px'}}>
                    <button
                        onClick={() => { sessionStorage.clear(); window.location.reload(); }}
                        style={{
                            padding: '2px 5px',
                            backgroundColor: 'transparent',
                            color: 'red',
                            border: '1px solid red',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            height: '100%',
                            marginLeft: '10px'
                        }}
                    >
                        RESET
                    </button>
                </li>
            </ul>
        </div>
    );

}